import { FormattedMessage, useIntl } from 'react-intl';
import { IconWarning } from '@/shared/ui/Icons';
import { useNavigation } from '@/processes/Router';
import Box from '@/shared/ui/Box';
import _get from 'lodash/get';
import { useGetWalletAddressQuery } from '@/shared/api/Stats';
import { useMinerAccount } from '@/processes/MinerAccounts';

const WarningGram = () => {
  const intl = useIntl();
  const { isGRAM } = useNavigation();
  const { account, coin, miner } = useMinerAccount();

  const { data: payoutAddress, isSuccess } = useGetWalletAddressQuery({ account, miner, coin }, { skip: !account || miner })
  const address = _get(payoutAddress, 'address', '')
  const valid = _get(payoutAddress, 'valid', false)

  return (isGRAM && !valid && address.length !== 0 ?
    <Box colorSchema="warning" className="mb-3 flex gap-2 max-w-[640px]">
      <IconWarning className="flex-shrink-0" height={16} width={16}/>
      <div className="flex-grow">
        <div className="font-bold text-xs mb-1">
          {intl.formatMessage({ id: 'gram.warning.title' })}
        </div>
        <div className="text-xs leading-4">
          <FormattedMessage id="gram.warning.desc" values={{
            span: (...chunks) => <span className="text-[#FF9500]">{chunks}</span>,
          }}/>

          <div className="mt-3">
            <FormattedMessage id="gram.warning.desc2"/>
          </div>
        </div>

      </div>
    </Box> : null);
}

export default WarningGram;
